import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMatch } from 'react-router-dom'
import { setIsSearchMode, setListBukkenStore, setPageActive, setPatternActive, setPayloadBukkenSearchStore, setProgressCondition } from '../features/common/bukkenSlice/stateBukken'
import { createLikeCondition } from '../utils/bukken/helpers/handlePayloadBukkenSearch'
import { INITIAL_PROGRESS_CONDITION } from '../utils/globalConstantUtil'
import APP_URL, { LONG_NAME } from '../declaration/URL'

const useSetDefaultStateBukkenSearch = () => {
  const dispatch = useDispatch();
  const progressCondition = useSelector((state) => state.stateBukken.progressCondition);

  const matchBukkenDetail       = useMatch(LONG_NAME(APP_URL.bukken.bukkenDetail));
  const matchBukken             = useMatch(LONG_NAME(APP_URL.bukken.bukkenList));
  const matchBukkenRegister     = useMatch(LONG_NAME(APP_URL.bukken.bukkenRegister));
  const matchBukkenEdit         = useMatch(LONG_NAME(APP_URL.bukken.bukkenEdit));
  const matchBukkenRecover      = useMatch(LONG_NAME(APP_URL.bukken.bukkenRecoverOrDelete));
  const matchBukkenRelation     = useMatch(LONG_NAME(APP_URL.bukken.bukkenRelatedInfo));
  const matchBukkenSettingList  = useMatch(LONG_NAME(APP_URL.bukken.bukkenSettingList));
  
  const matchBukkenFile       = useMatch(LONG_NAME(APP_URL.bukken.bukkenFiles));
  const matchBukkenDrawing    = useMatch(LONG_NAME(APP_URL.bukken.bukkenDrawing));
  const matchBukkenInspection = useMatch(LONG_NAME(APP_URL.bukken.bukkenInspection));
  const matchBukkenPhoto      = useMatch(LONG_NAME(APP_URL.bukken.bukkenImages));
  const matchBukkenPhotobook  = useMatch(LONG_NAME(APP_URL.photobook.photobooks));
  const matchBukkenSearch  = useMatch(LONG_NAME(APP_URL.sp.bukkenSearch));
  


  const isPageMatch =  !matchBukkenDetail &&
                       !matchBukken && 
                       !matchBukkenRegister && 
                       !matchBukkenRecover && 
                       !matchBukkenRelation &&
                       !matchBukkenSettingList &&
                       !matchBukkenEdit &&
                       !matchBukkenFile &&
                       !matchBukkenDrawing &&
                       !matchBukkenInspection &&
                       !matchBukkenPhoto &&
                       !matchBukkenPhotobook &&
                       !matchBukkenSearch
                       ;
  
  useEffect(() => {
    if (isPageMatch) {
      dispatch(setPageActive(1))
      dispatch(setPatternActive(""));
      // dispatch(setPayloadBukkenSearchStore({
      //   info: {
      //     progress: progressCondition.map(createLikeCondition)
      //   }
      // }))
      dispatch(setProgressCondition(INITIAL_PROGRESS_CONDITION));
      dispatch(setListBukkenStore([]));
      dispatch(setIsSearchMode(true));
    }
  }, [dispatch,isPageMatch, progressCondition])
}

export default useSetDefaultStateBukkenSearch